var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.45 21.5C18.3 21.5 16.2043 21.0207 14.163 20.062C12.121 19.104 10.3127 17.8373 8.738 16.262C7.16267 14.6873 5.896 12.879 4.938 10.837C3.97933 8.79567 3.5 6.7 3.5 4.55C3.5 4.25 3.6 4 3.8 3.8C4 3.6 4.25 3.5 4.55 3.5H8.6C8.83333 3.5 9.04167 3.575 9.225 3.725C9.40833 3.875 9.51667 4.06667 9.55 4.3L10.2 7.8C10.2333 8.03333 10.2293 8.24567 10.188 8.437C10.146 8.629 10.05 8.8 9.9 8.95L7.5 11.4C8.2 12.6 9.075 13.725 10.125 14.775C11.175 15.825 12.3333 16.7333 13.6 17.5L15.95 15.15C16.1 15 16.296 14.8873 16.538 14.812C16.7793 14.7373 17.0167 14.7167 17.25 14.75L20.7 15.45C20.9333 15.5 21.125 15.6123 21.275 15.787C21.425 15.9623 21.5 16.1667 21.5 16.4V20.45C21.5 20.75 21.4 21 21.2 21.2C21 21.4 20.75 21.5 20.45 21.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.3bddf699abcbb5dea50376ce85ae7640.svg";
export { ForwardRef as ReactComponent };